export default __webpack_public_path__ + "static/media/android_code.4dfeea7e.png";